import Reflux from "reflux";
import { singletonActions } from "logic/singleton";
const AuthenticationActions = singletonActions(
  "enterprise.Authentication",
  () => Reflux.createActions({
    loadTeamsPaginated: { asyncResult: true },
    triggerTeamSync: { asyncResult: true }
  })
);
export default AuthenticationActions;
